import {observable, action} from 'mobx'

class ClientStore {

    @observable clientData = {};
    @action setClientData = (data) => {
        this.clientData = data;
    }
}


const clientStore = new ClientStore()
export default clientStore


// WEBPACK FOOTER //
// ./src/stores/clientDetails.js